import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation deleteTreeEditorData(
    $tenantId: ID!
    $zoneId: ID!
    $deletion: DataDeletion!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        deleteData(deletion: $deletion)
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.always(undefined)

export const executor = graphql.createExecutor<
  graphql.schema.DeleteTreeEditorDataMutation,
  undefined,
  graphql.schema.DeleteTreeEditorDataMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
